import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import { debounce } from 'lodash-es';
import { Html5Qrcode } from 'html5-qrcode';
import { getScreenOrientation } from '~/core/functions';
import { useToggleable } from '~/core/composables';
export default defineComponent({
  name: 'QrReaderPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'scanned', 'error:scan', 'error:camera'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var refProps = toRefs(props);
    var reader = ref(null);
    var html5QrCode = ref(null);
    var isLoading = ref(false);
    var labelStyle = ref({
      top: '0px'
    });
    var isResizeAvailable = ref(false);
    var scanRegionSize = ref(228); // Сделано как ref, чтобы тест подхватывал значение правильно

    var _useNuxtApp = useNuxtApp(),
      $captureException = _useNuxtApp.$captureException;
    var _useToggleable = useToggleable(refProps.value, emit, 'input'),
      isActive = _useToggleable.isActive,
      hide = _useToggleable.hide,
      show = _useToggleable.show;
    watch(isActive, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var cameras;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!val) {
                _context.next = 25;
                break;
              }
              _context.prev = 1;
              isLoading.value = true;
              _context.next = 5;
              return Html5Qrcode.getCameras();
            case 5:
              cameras = _context.sent;
              if (cameras.length) {
                _context.next = 9;
                break;
              }
              emit('error:camera', 'unavailable');
              return _context.abrupt("return");
            case 9:
              _context.next = 11;
              return nextTick();
            case 11:
              _context.next = 13;
              return initHtml5QrCode();
            case 13:
              isLoading.value = false;
              resetLabelStyle();
              isResizeAvailable.value = true;
              _context.next = 24;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](1);
              destroyHtml5QrCode();
              isResizeAvailable.value = false;
              hide();
              emit('error:camera', _context.t0);
            case 24:
              return _context.abrupt("return");
            case 25:
              destroyHtml5QrCode();
              isResizeAvailable.value = false;
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 18]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    onBeforeUnmount(function () {
      destroyHtml5QrCode();
    });
    function initHtml5QrCode() {
      return _initHtml5QrCode.apply(this, arguments);
    }
    function _initHtml5QrCode() {
      _initHtml5QrCode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              html5QrCode.value = new Html5Qrcode('reader');
              _context3.next = 4;
              return html5QrCode.value.start({}, {
                fps: 24,
                qrbox: {
                  width: scanRegionSize.value,
                  height: scanRegionSize.value
                },
                videoConstraints: {
                  facingMode: {
                    exact: 'environment'
                  },
                  height: {
                    max: isPortraitOrientation() ? innerWidth : innerHeight,
                    ideal: isPortraitOrientation() ? innerWidth : innerHeight,
                    min: 300
                  },
                  width: {
                    min: 300,
                    max: isPortraitOrientation() ? innerHeight : innerWidth,
                    ideal: isPortraitOrientation() ? innerHeight : innerWidth
                  }
                }
              }, function (_, result) {
                emit('scanned', _objectSpread(_objectSpread({}, result), {}, {
                  pause: pauseScanner,
                  resume: function resume() {
                    return html5QrCode.value.resume();
                  },
                  loading: function loading(val) {
                    isLoading.value = val;
                  }
                }));
              }, function (_, err) {
                emit('error:scan', _objectSpread(_objectSpread({}, err), {}, {
                  pause: pauseScanner,
                  resume: function resume() {
                    return html5QrCode.value.resume();
                  },
                  loading: function loading(val) {
                    isLoading.value = val;
                  }
                }));
              });
            case 4:
              _context3.next = 10;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              $captureException(_context3.t0, {
                method: 'initHtml5QrCode',
                component: 'QrReaderPopup'
              });
              throw _context3.t0;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 6]]);
      }));
      return _initHtml5QrCode.apply(this, arguments);
    }
    function resetLabelStyle() {
      labelStyle.value.top = "".concat(window.innerHeight / 2 + scanRegionSize.value / 2 + 57, "px");
    }
    function pauseScanner(shouldPauseVideo) {
      html5QrCode.value.pause(shouldPauseVideo);
      hideDefaultPausedLabel();
    }

    // Хак, прячущий желтую строку с информацией о паузе (вшутую в библиотеку)
    function hideDefaultPausedLabel() {
      var target = reader.value.children[reader.value.childElementCount - 1];
      if ((target === null || target === void 0 ? void 0 : target.textContent) !== 'Scanner paused') {
        return;
      }
      target.style.display = 'none';
    }
    function handleResize() {
      if (!isActive.value || !isResizeAvailable.value || isLoading.value) {
        return;
      }
      debouncedRefresh();
    }
    var debouncedRefresh = debounce(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return nextTick();
          case 2:
            _context2.next = 4;
            return destroyHtml5QrCode();
          case 4:
            initHtml5QrCode();
            resetLabelStyle();
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), 200);
    function destroyHtml5QrCode() {
      return _destroyHtml5QrCode.apply(this, arguments);
    }
    function _destroyHtml5QrCode() {
      _destroyHtml5QrCode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _html5QrCode$value, _html5QrCode$value2;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (_html5QrCode$value = html5QrCode.value) === null || _html5QrCode$value === void 0 ? void 0 : _html5QrCode$value.stop();
            case 3:
              (_html5QrCode$value2 = html5QrCode.value) === null || _html5QrCode$value2 === void 0 ? void 0 : _html5QrCode$value2.clear();
              _context4.next = 9;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              $captureException(_context4.t0, {
                component: 'QrReaderPopup',
                method: 'destroyHtml5QrCode'
              });
            case 9:
              _context4.prev = 9;
              html5QrCode.value = null;
              return _context4.finish(9);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 6, 9, 12]]);
      }));
      return _destroyHtml5QrCode.apply(this, arguments);
    }
    function isPortraitOrientation() {
      return getScreenOrientation() === 'portrait';
    }
    expose({
      show: show,
      hide: hide
    });
    return {
      reader: reader,
      html5QrCode: html5QrCode,
      isLoading: isLoading,
      labelStyle: labelStyle,
      isResizeAvailable: isResizeAvailable,
      // для теста
      isActive: isActive,
      hide: hide,
      initHtml5QrCode: initHtml5QrCode,
      // для теста
      handleResize: handleResize,
      isPortraitOrientation: isPortraitOrientation
    };
  }
});